import { useEffect, useState } from "react";
import { api, errMsg } from "./api";
import { useApp } from "../context/AppCtx";

export function useFetch(url, deps = []) {
  const { tick } = useApp();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!url) { setLoading(false); return; }
    let live = true;
    setLoading(true);
    api.get(url).then((r) => { if (live) { setData(r.data); setError(null); } }).catch((e) => live && setError(errMsg(e))).finally(() => live && setLoading(false));
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, tick, n, ...deps]);
  return { data, error, loading, reload: () => setN((x) => x + 1), setData };
}

export function useSelect(key, fallback = null) {
  const { sel, setSel } = useApp();
  useEffect(() => {
    const p = new URLSearchParams(window.location.search).get("select");
    if (p) setSel(key, p);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);
  return [sel[key] || fallback, (v) => setSel(key, v)];
}

export const useRecords = (world, kind) => useFetch(`/records?world=${world}${kind ? `&kind=${kind}` : ""}`);
